import { fetchPetsServer } from '@/api/fetchPets';
import { fetchSolvedCasesServer } from '@/api/fetchSolvedCases';

export const lostPetsLoader = async () => {
  const filters = getFiltersFromLocalStorage();
  return await fetchPetsServer({ status: 'lost', filters });
};

export const foundPetsLoader = async () => {
  const filters = getFiltersFromLocalStorage();
  return await fetchPetsServer({ status: 'found', filters });
};

export const mapPetsLoader = async () => {
  const filters = getFiltersFromLocalStorage();
  return await fetchPetsServer({ filters });
};

export const solvedCasesLoader = async () => {
  return await fetchSolvedCasesServer();
};

const getFiltersFromLocalStorage = () => {
  try {
    const stored = localStorage.getItem('rescatapp_filters');
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};
